import type { ComponentType } from 'react';
import { FilePin } from './FilePin';
import { ImagePin } from './ImagePin';
import { ProviderFilePin } from './ProviderFilePin';
import { TweetPin } from './TweetPin';
import { UnknownPin } from './UnknownPin';
import { VideoPin } from './VideoPin';
import { WebLinkPin } from './WebLinkPin';
import {
  type PinKindFields,
  type PinMediaKind,
  pinMediaKindOf
} from './pinMediaKind';
import type { PinRendererProps } from './pinMediaRenderer';

/** One renderer per kind: a kind without one does not compile. */
const renderers: Record<PinMediaKind, ComponentType<PinRendererProps>> = {
  image: ImagePin,
  video: VideoPin,
  file: FilePin,
  'provider-file': ProviderFilePin,
  'web-link': WebLinkPin,
  tweet: TweetPin,
  unknown: UnknownPin
};

/** A pin shown in full, as its kind shows it. */
export function PinMedia({
  pin,
  autoPlay = false
}: {
  pin: PinKindFields;
  autoPlay?: boolean;
}) {
  const kind = pinMediaKindOf(pin);
  const Renderer = renderers[kind];
  return (
    <div
      data-pin-kind={kind}
      className="flex size-full items-center justify-center"
    >
      <Renderer pin={pin} autoPlay={autoPlay} />
    </div>
  );
}
